import React, { useEffect, useState } from 'react';

import { withStyles } from '@material-ui/core';
import appConstants from '../../../../appConstants';
import DataGrid from '@dataGrid';
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from './GridHeader';
import { getInternationalNumberFormat } from '../../../../utilities/appHelper'

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: '5px'
  }
});

const Grid = ({
  title,
  gridConfig,
  data,
  onSelection,
  totalLabel,
  classes,
  onMaximize,
  activeFilterName,
  isLoading,
  ...others
}) => {
  const [gridApi, setGridApi] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(appConstants.GRID_STATUS.LOADING);

  const constructStatusBar = (data) => [
    {
      label: getInternationalNumberFormat(data.length) + ' Total ' + totalLabel
    }
  ];

  const onSelectionChanged = () => {
    if (onSelection && gridApi?.api) {
      const selectedRows = gridApi.api.getSelectedRows();
      onSelection(selectedRows.length ? selectedRows[0] : null);
    }
  };

  const onGridReady = ({ api }) => {
    api.runCommand = () => {};
    setGridApi({ api });
  };

  const onRowDataUpdated = () => {
    onSelectionChanged();
  };

  useEffect(() => {
    if (isLoading) {
      setShowErrorMessage(appConstants.GRID_STATUS.LOADING);
    } else if (data === null) {
      setShowErrorMessage(appConstants.GRID_STATUS.ERROR);
    } else if (Array.isArray(data)) {
      setShowErrorMessage(appConstants.GRID_STATUS.SUCCESS);
    }
  }, [data, isLoading]);

  return (
    <div id="gridContainer" className={classes.container}>
      <GridHeader
        onSearchText={setSearchText}
        title={title}
        gridApi={gridApi?.api}
        onMaximize={onMaximize}
        exportFileName={activeFilterName}
      />
      <DataGrid
        defaultColDef={gridConfig.defaultColDef}
        columnDefs={gridConfig.columns}
        columnTypes={gridConfig.columnTypes}
        config={gridConfig}
        rowSelection={gridConfig.rowSelection}
        rowDeselection={gridConfig.rowDeselection}
        enableFilter={gridConfig.enableFilter}
        enableSorting={gridConfig.enableSorting}
        rowData={data || []}
        onGridReady={onGridReady}
        onSelectionChanged={onSelectionChanged}
        onRowDataUpdated={onRowDataUpdated}
        quickFilterText={searchText}
        panelLabel={(filteredData) => <StatusBar data={constructStatusBar(filteredData)} />}
        showErrorMessage={showErrorMessage}
        {...others}
      />
    </div>
  );
};

export default withStyles(styles)(Grid);
